import React from 'react';
import '../assets/css/NotFound.css'; // Import your CSS file

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404 Not Found</h1>
      <p>Oops! The page you are looking for might be under construction or does not exist.</p>
      <img src="https://example.com/error-image.jpg" alt="Error Illustration" />
    </div>
  );
};

export default NotFound;
